module.exports = __webpack_public_path__ + "img/alert-circle.e64d6c1d.svg";